import { useSelector } from "react-redux";
import { getItemCookie } from "../utils/cookie";
import { ID_HIDDEN_POPUP_INTRO_GIFT, KEY_LOCAL_TOUR_COMPLETE, CONFIG_SHWE_HOURS } from "./const";
import moment from 'moment';
import { curStateAccount, curStateHome } from "../Redux/selector";
import { useEffect, useState } from "react";

/**
 * Get current time in Myanmar Time (UTC+6:30)
 * @returns {moment.Moment} Current moment in MMT
 */
export const getMyanmarTime = () => {
  return moment().utcOffset("+06:30");
};

/**
 * Get current hour in Myanmar Time (0-23)
 * @returns {number} Current hour in MMT
 */
export const getMyanmarHour = () => {
  return getMyanmarTime().hour();
};

export const getUrlParamsFromJson = (data) => {
  return Object.keys(data)
    .map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&");
};

export async function checkImage(url) {
  try {
    const res = await fetch(url);
    const buff = await res.blob();
    return buff.type.startsWith("image/");
  } catch (error) {
    // console.log(error);
  }
}

export const handleGetDataTakePrizeMinigame = (dataAwardListMini) => {
  if (!dataAwardListMini) {
    return null;
  }
  const now = moment();
  const cookiePopupIntroGift = getItemCookie(ID_HIDDEN_POPUP_INTRO_GIFT);
  let dataTakePrize = dataAwardListMini.find((item) => {
    if (+item.type_take_prize === 1) {
      if (!cookiePopupIntroGift) {
        return item;
      }
      let isCheckIdShowed = false;

      cookiePopupIntroGift.forEach((gift) => {
        const diffInMinutes = now.diff(gift.timeShowPopup, 'minutes');

        if (+gift.idTakePrize === +item.id || Math.abs(diffInMinutes) <= 30) { //check điều kiện show popup khi trúng nhiều giải (nếu nhiều giải thì cách nhau ít nhất 30p)
          isCheckIdShowed = true;
        }
      });
      if (!isCheckIdShowed) {
        return item;
      }
    }
  });

  return dataTakePrize;
};

export const isIntroTourCompleted = (typeIntroTour) => {
  const tourComplete = localStorage.getItem(KEY_LOCAL_TOUR_COMPLETE);
  return tourComplete === "true" || typeIntroTour?.step === -1;
}

export const useShowPopup = (shouldShow) => {
  const { typeIntroTour } = useSelector(curStateHome);
  const selectorAccount = useSelector(curStateAccount);
  const dataRedux = useSelector((state) => state);
  if (!shouldShow) return false;
  if (localStorage.getItem("show-popup-advertisement") && !getItemCookie("show-popup-advertisement")) {

    return true;
  }

  if (!selectorAccount?.userInfo) {
    // do not include tour complete check if user is not logged in
    return shouldShow && !dataRedux?.reducerHome?.isClosePopupAdvertisement;
  }

  return shouldShow && isIntroTourCompleted(typeIntroTour) && !dataRedux?.reducerHome?.isClosePopupAdvertisement;
}

export const useShowPopupEvent = (shouldShow) => {
  const { typeIntroTour } = useSelector(curStateHome);
  const selectorAccount = useSelector(curStateAccount);

  if (!selectorAccount?.userInfo) {
    // do not include tour complete check if user is not logged in
    return shouldShow;
  }

  return shouldShow && isIntroTourCompleted(typeIntroTour);
}

export const useCountDown = () => {
  const [now, setNow] = useState(() => getMyanmarTime());

  // Tick every second
  useEffect(() => {
    const interval = setInterval(() => {
      setNow(getMyanmarTime());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  // Use CONFIG_SHWE_HOURS for bid time (19:00-21:00 MMT)
  const startTime = getMyanmarTime().set({
    hour: CONFIG_SHWE_HOURS.startBidTime,
    minute: 0,
    second: 0,
    millisecond: 0,
  });

  const endTime = getMyanmarTime().set({
    hour: CONFIG_SHWE_HOURS.endBidTime,
    minute: 0,
    second: 0,
    millisecond: 0,
  });

  const isInPeriod = now.isBetween(startTime, endTime, undefined, "[]");

  let targetTime;

  if (now.isBefore(startTime)) {
    // Before period → countdown to start
    targetTime = startTime;
  } else if (isInPeriod) {
    // During period → countdown to end
    targetTime = endTime;
  } else {
    // After period → countdown to tomorrow's start
    targetTime = startTime.clone().add(1, "day");
  }

  const diffSeconds = Math.max(0, targetTime.diff(now, "seconds"));
  const countdown = moment.utc(diffSeconds * 1000).format("HH:mm:ss");

  return {
    countdown,
    isInPeriod,
  };
};

export const handleNumericInput = (data) => {
  const value = data.replace(/[^0-9]/g, "");
  return value;
}

export const handleCheckAutoLogin = () => {
  const msisdn = document.getElementById("msisdn_myid").value;
  const tokenEncoded = document.getElementById("token_myid").value;
  const hasValidAutoLoginParams =
    msisdn &&
    tokenEncoded &&
    msisdn !== '<!--# echo var="msisdnmytel"-->' &&
    tokenEncoded !== '<!--# echo var="tokenmytel"-->';
  return hasValidAutoLoginParams;
};
